import { LIGHT_THEME } from 'shared/constants';

import { ApiMapper } from './types';

const profileMapper: ApiMapper<any, any> = {
  mapFromApi: (profile) => {
    const preferencesObj = profile.preferences || {};

    return {
      ...profile,
      preferences: {
        ...preferencesObj,
        themeMode: preferencesObj.themeMode && preferencesObj.themeMode !== 'NONE'
          ? preferencesObj.themeMode.toLowerCase()
          : LIGHT_THEME,
      },
    };
  },
};

export default profileMapper;
